var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-view"},[_c('b-img',{attrs:{"thumbnail":"","src":_vm.photoSrc,"width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }